import { Navigate, createBrowserRouter } from 'react-router-dom'
import { authRoutes } from './pages/auth/routes'
import { dashboardRoutes } from 'pages/dashboard/routes'
import { accountRoutes } from 'pages/account/routes'
import { easyPayLayout } from 'pages/easyPay/routes'
import { fundRoutes } from 'pages/fund/routes'
import { cashboxRoutes } from 'pages/cashbox/routes'
import { loansRoutes } from 'pages/loans/routes'
import { walletRoutes } from 'pages/wallet/routes'
import { bankCards } from 'pages/bankAccounts/routes'
import { gatewayRoutes } from './pages/gatewayCallback/routes'
import { addBox } from 'pages/addMoneyPool/routes'
import { promissoryRoutes } from 'pages/promissory/routers'
import { AuthenticationUserRoutes } from 'pages/authenticationUsers/routers'
import { authNationalCode } from 'pages/auth_national_code/routes'
import { guaranteesRoutes } from 'pages/guarantees/routes'

export const routes = createBrowserRouter([
    // Landing on /funds meant the home page was something you only reached by
    // tapping its tab — which was defensible while it was a marketing page and
    // is not now that it carries what you owe.
    //
    // Auth handling is deliberately unchanged: a logged-out user hitting `/`
    // now follows exactly the path they already followed at `/funds` — the
    // first API call 401s and the axios interceptor sends them to login. No
    // ProtectedRoute here, so this adds no new redirect behaviour to the one
    // route every single user loads.
    //
    // This redirect is also the *only* definition of "where does a login land".
    // Every login path navigates to `POST_LOGIN_PATH` (= '/') rather than to
    // '/home' directly — see `utilities/navigation` for why the root and not
    // the deep path.
    { path: '/', element: <Navigate replace to="home" /> },
    ...authRoutes,
    ...dashboardRoutes,
    ...accountRoutes,
    ...easyPayLayout,
    ...fundRoutes,
    ...cashboxRoutes,
    ...loansRoutes,
    ...walletRoutes,
    ...bankCards,
    ...gatewayRoutes,
    ...addBox,
    ...promissoryRoutes,
    ...AuthenticationUserRoutes,
    ...authNationalCode,
    ...guaranteesRoutes,
])
